import { useApi } from '@/api';
import { Link, TableSkeleton } from '@/components';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';
import { DATE_MAPPING } from '@/constants';
import { useSearchParams } from '@/hooks';
import {
  CryptoIcon,
  CurrencyValue,
  Flex,
  PercentageValue,
  WalletAddress,
  DataTable,
  Box,
  RelativeDateTime
} from '@blockanalitica/ui';

export default function DSRDepositorsTable({ pagination, sorting, search }) {
  const [daysAgo] = useSearchParams('days_ago', '1');
  const [data, error] = useApi({
    url: '/save/dsr/depositors/',
    queryParams: {
      p: pagination.currentPage,
      p_size: pagination.pageSize,
      order: sorting.currentSorting,
      days_ago: daysAgo,
      search: search
    }
  });

  if (error) {
    throw error;
  }
  const date = DATE_MAPPING[daysAgo];
  if (data) {
    const columns: TableColumn[] = [
      {
        header: 'Wallet Address',
        getCell: (row) => (
          <WalletAddress
            address={row.wallet_address}
            options={{
              inline: true,
              sizes: { blockie: '0' }
            }}
          />
        )
      },
      {
        header: (
          <Flex
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="3xs">
            Supply
            <CryptoIcon name="DAI" size="0" />
          </Flex>
        ),
        getCell: (row) => (
          <CurrencyValue value={row.total_balance} options={{}} />
        ),
        getCellBottom: (row) => (
          <CurrencyValue
            fontSize="-1"
            value={row.total_balance_change}
            options={{ trend: true, iconSize: '-1' }}
          />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'total_balance'
      },
      {
        header: `Change (${date})`,
        getCell: (row) => (
          <CurrencyValue
            value={row.balance_change}
            options={{
              trend: true,
              iconSize: '0'
            }}
          />
        ),
        getCellBottom: (row) => (
          <PercentageValue
            color="muted"
            fontSize="-1"
            value={row.balance_change_percentage}
            options={{
              nullable: (
                <Box color="muted" fontSize="-1">
                  -
                </Box>
              )
            }}
          />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'balance_change'
      },
      {
        header: 'Latest Activity',
        getCell: (row) => (
          <Box color="muted">
            <RelativeDateTime value={row.datetime} />
          </Box>
        ),
        sortingField: 'order_index',
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      }
    ];

    return (
      <DataTable
        rows={data['results']}
        columns={columns}
        getKey={(row) => row.wallet_address}
        rowLinkProps={{
          to: (row) => row.wallet_address,
          // @ts-ignore
          linkComponent: Link
        }}
        sorting={sorting}
        pagination={{
          ...pagination,
          totalRecords: data.count
        }}
      />
    );
  }
  return <TableSkeleton />;
}
